import React, { useEffect, useState, useMemo } from "react";
import { Container, Input, Table, FormGroup, Label, Col, Button } from "reactstrap";
import { Formik, Form, Field } from "formik";
// import Modal from "react-modal"
import { getCustomStyles } from "../../share/ModalStyle";
import { Loading } from "../../share/loading";
import { useTable, useSortBy, useGlobalFilter, usePagination } from "react-table";
import * as Yup from "yup";
import "../../share/form.css";
import './ProposalStyle.css'
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css'
import { NumberWithCommas } from "../../share/NumberWithCommas";
import { RenderCustomHeader } from "../../share/RenderCustomHeader";
import { ConvertDateToThaiBuddhist } from "../../share/ConvertDateToThaiBuddhist";
import { ConvertDateFormat } from "../../share/ConvertDateFormat";
// import { CgClose } from "react-icons/cg";
// import { NumericFormat } from 'react-number-format';
// import { CustomInputNumeric } from '../../share/CustomInputNumeric'
// import Swal from "sweetalert2";

export function ProposedToTheSubCommittee3ViewComponent() {
    const myCustomStyles = getCustomStyles()
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    const [meetingDate, setMeetingDate] = useState("")
    const [meetingYear, setMeetingYear] = useState("")
    const [meetingNo, setMeetingNo] = useState("")
    const [meetingYearSelect, setMeetingYearSelect] = useState([])
    const [meetingNoSelect, setMeetingNoSelect] = useState([]);

    function useInstance(instance) {
        // console.log("instance", instance);
        const { allColumns } = instance;
        // setDataForCheck(data);
        // setDataForCheck(data);
        let rowSpanHeaders = [];


        allColumns.forEach((column, i) => {
            // console.log("column",column)
            const { id, enableRowSpan } = column;
            // console.log("id",id)
            if (enableRowSpan !== undefined) {
                rowSpanHeaders = [
                    ...rowSpanHeaders,
                    { id, topCellValue: null, topCellIndex: 0, }
                ];
            }
        });
        // console.log("rowSpanHeaders",rowSpanHeaders)

        Object.assign(instance, { rowSpanHeaders });
    }

    const columns = useMemo(
        () => [

            {
                Header: "ข้อมูลผู้ขอกู้",
                columns: [
                    {
                        Header: "ลำดับ",
                        accessor: 'No',
                        id: "No",
                        enableRowSpan: true,
                        // accessor: (_row, i) => i + 1,
                        // Cell: (row) => {
                        //   return <div>{Number(row.row.id) + 1}</div>;
                        // },
                        // accessor: "borrowId",
                    },
                    {
                        Header: "เลขที่คำขอ",
                        accessor: "borrowNumber",
                        enableRowSpan: true,


                    },
                    {
                        Header: "ผู้ขอกู้",
                        accessor: "employee",
                        enableRowSpan: true,

                    },
                    {
                        Header: "ประเภท",
                        accessor: "borrowType",
                        enableRowSpan: true
                    },
                    {
                        Header: "ประเภทกิจการ",
                        accessor: "businessType",
                        enableRowSpan: true,

                    },
                    {
                        Header: "สาขาอาชีพ",
                        accessor: "lawOccupationName",
                        enableRowSpan: true,
                        Cell: ({ value }) => (
                            <>{value ? value : "-"}</>
                        ),

                    },
                    {
                        Header: "ทุนจดทะเบียน",
                        accessor: "registeredCapital",
                        enableRowSpan: true,
                        Cell: ({ value }) => (
                            <>{value ? NumberWithCommas(value) : "-"}</>
                        ),
                    },
                    {
                        Header: "จำนวนลูกจ้างทั้งสิ้น (คน)",
                        accessor: "employeeAmount",
                        Cell: ({ value }) => {
                            // console.log("value",value)
                            return (
                                <>{value ? NumberWithCommas(Number(value)) : "-"}</>
                            )
                        },
                        enableRowSpan: true,

                    },
                    {
                        Header: "ประเภทการฝึก",
                        accessor: "inOutTypeName",
                        Cell: ({ value }) => (
                            <>{value ? value : "-"}</>
                        ),
                        enableRowSpan: true,

                    },
                ]
            },

            {
                Header: "รายละเอียดการขอกู้ยืมเงิน",
                columns: [
                    {
                        Header: "หลักสูตร",
                        accessor: "trainCourseId",
                        Cell: ({ row, value }) => (
                            <>{row.original.courseName}</>
                        ),
                        enableRowSpan: true

                    },
                    // {
                    //     Header: "สาขาอาชีพ",
                    //     accessor: "occupationTrain",
                    //     enableRowSpan: true,
                    // },
                    {
                        Header: "จำนวนรุ่น",
                        accessor: "classAmount",
                        enableRowSpan: true
                    },
                    {
                        Header: "ระยะเวลาการฝึกอบรม (ขั่วโมง)",
                        accessor: "periodTrainCourse",
                        Cell: ({ row, value }) => (
                            <>
                                {value} ชั่วโมง
                                <div>({row.original.dayAmount} วัน)</div>
                            </>
                        )
                    },
                    {
                        Header: "วันที่เริ่มฝึก",
                        accessor: "startDate",
                        Cell: ({ row, value }) => (
                            <>
                                <div>{value}</div>
                                (รุ่นที่ {row.original.classItem})
                            </>
                        ),
                    },
                    {
                        Header: "วันที่จบการฝึก",
                        accessor: "endDate",
                        Cell: ({ row, value }) => (
                            <>
                                <div>{value}</div>
                                (รุ่นที่ {row.original.classItem})
                            </>
                        ),
                    },
                    {
                        Header: "จำนวน (คน)",
                        accessor: "classEmployeeAmount"
                    },
                    {
                        Header: "วงเงินที่ขอกู้ (บาท)",
                        accessor: "payment",
                        Cell: ({ value }) => (
                            <>{value ? NumberWithCommas(value) : "-"}</>
                        )
                    },
                ]
            },
            {
                Header: "หน่วยงานที่รับคำขอกู้ยืม",
                accessor: "site",
                enableRowSpan: true
            }

        ],
        [data]
    );

    useEffect(() => {
        GetBorrowThree()
    }, [meetingNo, meetingYear, meetingDate])

    async function GetBorrowThree() {
        setLoading(true)
        try {
            let res = await fetch(`api/ProposalBorrow/getResultProposalTrain/${meetingNo}/${meetingYear}/${meetingDate}`);
            let resJson = await res.json();
            let newData = [];
            console.log("resJson", resJson.dataenum)
            await resJson.dataenum?.forEach((borrow, index) => {
                borrow.courseTrains?.forEach((course) => {
                    course.classTrains?.forEach((trainClass) => {
                        newData.push({
                            No: index + 1,
                            borrowId: borrow.borrowId,
                            borrowNumber: borrow.borrowNumber,
                            employee: borrow.employee,
                            borrowType: borrow.borrowType,
                            businessType: borrow.businessType,
                            registeredCapital: borrow.registeredCapital,
                            employeeAmount: borrow.employeeAmount,
                            name: borrow.name,
                            position: borrow.position,
                            site: borrow.site,
                            trainCourseId: course.trainCourseId,
                            courseName: course.courseName,
                            inOutTypeName: course.inOutTypeName,
                            trainingTypeName: course.trainingTypeName,
                            occupationTrain: course.occupationTrain,
                            classAmount: course.classAmount,
                            startDate: trainClass.startDate,
                            endDate: trainClass.endDate,
                            amountApprove: trainClass.amountApprove,
                            statusApprove: trainClass.statusApprove,
                            dayAmount: trainClass.dayAmount,
                            payment: trainClass.payment,
                            classEmployeeAmount: trainClass.employeeAmount,
                            periodTrainCourse: course.periodTrainCourse,
                            classItem: trainClass.classItem,
                            trainClassId: trainClass.trainClassId,
                            lawOccupationName: borrow.lawOccupationName

                        })
                    })
                })
            })
            setData(newData)
        } catch (e) {
            console.log("err =>", e)
        } finally {
            setLoading(false)
        }
    }
    useEffect(() => {
        async function GetMeetingForSelect() {
            setLoading(true)
            try {
                let res = await fetch(`api/ProposalBorrow/getMeetingNoSelect`);
                let resJson = await res.json();
                setMeetingNoSelect(resJson.dataenum);
            } catch (e) {
                console.log("err =>", e)
            } finally {
                setLoading(false)
            }
        }
        GetMeetingForSelect()

    }, [])

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        rowSpanHeaders,

        page,
        // nextPage,
        // previousPage,
        // canNextPage,
        // canPreviousPage,
        // pageOptions,
        // gotoPage,
        // pageCount,
        setPageSize,
        state,
        setGlobalFilter
    } = useTable({
        columns,
        data
    },
        (hooks) => { hooks.useInstance.push(useInstance) },
        useGlobalFilter,
        useSortBy,
        usePagination
    );
    const { pageSize } = state

    const fromInitialValues = {
        meetingNo: "",
        meetingYear: "",
        meetingDate: ""
    }

    return (
        <Formik
            initialValues={fromInitialValues}
            enableReinitialize
        >
            {({ values, errors, touched, setFieldValue, handleBlur, handleChange }) => {

                async function getYearForSelect(e) {
                    let postData = new FormData()
                    postData.append("meetingNo", e.target.value)
                    // console.log("meetingNo", e.target.value)
                    try {
                        let res = await fetch("api/ProposalBorrow/getMeetingYearSelect", {
                            method: "POST",
                            body: postData
                        })
                        let resJson = await res.json()
                        setMeetingYearSelect(resJson.dataenum)
                    } catch (e) {
                        console.log("err", e)
                    }
                }
                return (
                    <Container>
                        {!loading ? (
                            <>

                                <div className="mb-2">
                                    <Form
                                        className=""
                                        // onSubmit={handleSubmit}
                                        autoComplete="off"
                                    >
                                        <FormGroup row>
                                            <Label for="" sm={1}>
                                                ครั้งที่
                                            </Label>
                                            <Col sm={3}>
                                                <Input
                                                    name="meetingNo"
                                                    type="select"
                                                    className="text-center w-100 rounded-pill input-color"
                                                    onChange={(e) => {
                                                        handleChange(e)
                                                        getYearForSelect(e)
                                                        setMeetingNo(e.target.value)
                                                    }}
                                                    onBlur={handleBlur}
                                                    value={values.meetingNo}
                                                >
                                                    <option defaultValue={"กรุณาเลือก"}>
                                                        กรุณาเลือก
                                                    </option>
                                                    {meetingNoSelect.map((item, k) => (
                                                        <option key={k} value={item.meetingNo}>
                                                            {item.meetingNo}
                                                        </option>
                                                    ))}
                                                </Input>
                                            </Col>
                                            <Label for="" sm={1}>
                                                ปี
                                            </Label>
                                            <Col sm={3}>
                                                <Input
                                                    name="meetingYear"
                                                    type="select"
                                                    className="text-center w-100 rounded-pill input-color"
                                                    onChange={(e) => {
                                                        handleChange(e)
                                                        setMeetingYear(e.target.value)
                                                    }}
                                                    onBlur={handleBlur}
                                                    value={values.meetingYear}
                                                >

                                                    <option defaultValue={"กรุณาเลือก"}>
                                                        กรุณาเลือก
                                                    </option>
                                                    {meetingYearSelect.map((year, i) => (
                                                        <option key={i} value={year.meetingYear}>
                                                            {year.meetingYear}
                                                        </option>
                                                    ))}
                                                </Input>
                                            </Col>
                                            <Label for="" sm={1}>
                                                วันที่
                                            </Label>
                                            <Col sm={3}>
                                                <Field name="meetingDate">
                                                    {({ field, meta, form }) => {
                                                        return (
                                                            <DatePicker
                                                                selected={field.value ? new Date(field.value) : null}
                                                                locale="th-buddhist"
                                                                showIcon
                                                                calendarClassName="thai-buddhist"
                                                                dateFormat="dd MMMM yyyy"
                                                                value={ConvertDateToThaiBuddhist(field.value)}
                                                                isClearable={true}
                                                                placeholderText="กรุณาเลือก"
                                                                renderCustomHeader={RenderCustomHeader}
                                                                onChange={(date) => {
                                                                    form.setFieldValue(field.name, ConvertDateFormat(date))
                                                                    setMeetingDate(ConvertDateFormat(date))
                                                                }}
                                                                customInput={
                                                                    <Input
                                                                        type="text"
                                                                        className={
                                                                            touched.meetingDate && errors.meetingDate
                                                                                ? "input-error rounded-pill text-center input-color custom-placeholder"
                                                                                : "rounded-pill text-center input-color custom-placeholder"
                                                                        }
                                                                        value={ConvertDateToThaiBuddhist(field.value)}
                                                                        onChange={() => { }}
                                                                        onBlur={field.onBlur}
                                                                    />
                                                                }
                                                            />
                                                        )
                                                    }}
                                                </Field>
                                            </Col>

                                        </FormGroup>
                                    </Form>

                                </div>
                                <div className="d-flex justify-content-end align-items-center mt-3">
                                    <div className="d-flex align-items-center ">
                                        <span className="me-2">
                                            แสดง {" "}
                                        </span>

                                        <Input className="input-color rounded-pill" type="select" value={pageSize} onChange={e => setPageSize(Number(e.target.value))}>
                                            {
                                                [5, 10, 25, 50, 75, 100].map(pageSize => (
                                                    <option key={pageSize} value={pageSize}>
                                                        {pageSize}
                                                    </option>
                                                ))
                                            }
                                        </Input>
                                        <span className="mx-2">{" "} รายการ {" "}</span>

                                    </div>
                                    <Button className="btn border border-1 mx-5 w-25 btn-green" href={`api/ProposalBorrow/getExeclthree/${meetingNo}/${meetingYear}/${meetingDate}`} download>Export Excel</Button>
                                    {/* <SearchFilter search={globalFilter} setSearch={setGlobalFilter}/> */}
                                </div>
                                <div style={{ overflowX: "auto" }} className="mt-3">
                                    <Table style={{ minWidth: "max-content", outline: "none" }} className="styled-table text-center" bordered {...getTableProps()}>
                                        <thead className='styles-thead'>

                                            {headerGroups.map((headerGroup) => {
                                                return (
                                                    <tr {...headerGroup.getHeaderGroupProps()}>
                                                        {headerGroup.headers.map((column) => {
                                                            return (
                                                                <th {...column.getHeaderProps()}>
                                                                    {column.render("Header")}
                                                                </th>
                                                            )

                                                        })}
                                                    </tr>
                                                )
                                            })}
                                        </thead>


                                        <tbody {...getTableBodyProps()}>
                                            {rows.map((row, i) => {
                                                prepareRow(row);
                                                // console.log("row", row)
                                                // console.log("pagesize", pageSize)
                                                // console.log("data", data)
                                                for (let j = 0; j < row.allCells.length; j++) {
                                                    let cell = row.allCells[j];
                                                    let currentBorrowNumberForCheck = rowSpanHeaders.find((x) => x.id === "borrowNumber");
                                                    let rowSpanHeader = rowSpanHeaders.find((x) => x.id === cell.column.id);
                                                    if (rowSpanHeader !== undefined) {

                                                        if (rowSpanHeader.topCellValue === null || rowSpanHeader.topCellValue !== cell.value) {
                                                            cell.isRowSpanned = false;
                                                            rowSpanHeader.topCellValue = cell.value;
                                                            rowSpanHeader.topCellIndex = i;
                                                            cell.rowSpan = 1;
                                                        } else {
                                                            if (rowSpanHeader.id !== "borrowNumber") {
                                                                if (currentBorrowNumberForCheck.topCellValue !== data[i !== 0 ? i - 1 : 0].borrowNumber) {
                                                                    cell.isRowSpanned = false;
                                                                    rowSpanHeader.topCellValue = cell.value;
                                                                    rowSpanHeader.topCellIndex = i;
                                                                    cell.rowSpan = 1;
                                                                } else {
                                                                    if (rowSpanHeader.id === "inOutTypeName" || rowSpanHeader.id === "occupationTrain" || rowSpanHeader.id === "classAmount") {
                                                                        // console.log("inOutTypeName")
                                                                        if (data[i].trainCourseId === data[i !== 0 ? i - 1 : 0].trainCourseId) {
                                                                            rows[rowSpanHeader.topCellIndex].allCells[j].rowSpan++;
                                                                            cell.isRowSpanned = true;
                                                                        } else if (rowSpanHeader.id === "registeredCapital") {
                                                                            rows[rowSpanHeader.topCellIndex].allCells[j].rowSpan++;
                                                                            cell.isRowSpanned = true;
                                                                        } else {
                                                                            cell.isRowSpanned = false;
                                                                            rowSpanHeader.topCellValue = cell.value;
                                                                            rowSpanHeader.topCellIndex = i;
                                                                            cell.rowSpan = 1;
                                                                        }
                                                                    } else {
                                                                        rows[rowSpanHeader.topCellIndex].allCells[j].rowSpan++;
                                                                        cell.isRowSpanned = true;
                                                                    }
                                                                }
                                                            } else {
                                                                rows[rowSpanHeader.topCellIndex].allCells[j].rowSpan++;
                                                                cell.isRowSpanned = true;
                                                            }
                                                        }
                                                    }


                                                }
                                                return null;
                                            })}


                                            {!page.length ? (
                                                <>
                                                    <tr>
                                                        <td className="text-center" colSpan="13">ไม่มีข้อมูล</td>
                                                    </tr>

                                                </>
                                            ) : (
                                                <>
                                                    {rows.map((row) => {
                                                        if (row.original.No > pageSize) {
                                                            return null
                                                        } else {
                                                            return (
                                                                <tr {...row.getRowProps()}>
                                                                    {row.cells.map((cell) => {
                                                                        if (cell.isRowSpanned) {
                                                                            return null;
                                                                        } else {
                                                                            return (
                                                                                <td rowSpan={cell.rowSpan} {...cell.getCellProps()}>
                                                                                    {cell.render("Cell")}
                                                                                </td>
                                                                            );
                                                                        }

                                                                    })}
                                                                </tr>
                                                            );
                                                        }
                                                    })}
                                                </>
                                            )}

                                        </tbody>
                                    </Table>

                                </div>
                            </>
                        ) : (<Loading />)}

                    </Container>
                )
            }}
        </Formik>



    )

}